"use client"

import { Col, Row } from "antd"
import ProductPreviewSkeleton from "./ProductPreview.skeleton"
import ProductPanelSkeleton from "./ProductPanel.skeleton"


const ProductSkeleton = () => {

  return (
    <Row justify="center" className="page product">
      <Col className="page__section">
        <Row justify="center" gutter={[15, 15]} style={{ height: '100%' }}>
          <Col xs={24} md={24} lg={15} xl={{ flex: 1 }}>
            <Row style={{ height: '100%' }}>
              <Col span={24}>
                <ProductPreviewSkeleton />
              </Col>
            </Row>

          </Col>
          <Col xs={24} md={20} lg={9} xl={{ flex: "45rem" }}>
            <Row>
              <Col span={24}>
                <ProductPanelSkeleton />
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default ProductSkeleton